import {
  getSession as nextAuthGetSession,
  signIn as nextAuthSignIn,
  signOut as nextAuthSignOut,
  useSession as nextAuthUseSession,
} from 'next-auth/react';
import { AuthSession, AuthSessionContextValue } from './model';
export { SessionProvider } from 'next-auth/react';

export const getSession = async (): Promise<AuthSession | null> => {
  const session = (await nextAuthGetSession()) as AuthSession | null;
  return session;
};

export const signIn = async (options?: { callbackUrl?: string }): Promise<void> => {
  await nextAuthSignIn('keycloak', options);
};

export const signOut = async (): Promise<void> => {
  await nextAuthSignOut({ redirect: true });
};

export const useSession = (): AuthSessionContextValue => {
  const context = nextAuthUseSession();
  return { session: context.data, status: context.status, updateSession: context.update } as AuthSessionContextValue;
};
